module.exports = __webpack_public_path__ + "static/media/item_5_10_comp.97201fec.png";